import React from "react";
import { Link } from "react-router-dom";
import OfferingCard from "../components/OfferingCard";
import RequestCallForm from "../components/RequestCallForm";
import config from "../config";
import {
  IN_HOME,
  emailHref,
  inHomePriceText,
  paymentMethodText,
  sessionCancellationText,
} from "../data/offerings";
import { CURRENCY_NOTE } from "../data/practice";
import "./Offerings.css";

/** In-home art therapy in Nassau: email to book (not in the online catalog). */
export default function InHomeArtTherapy() {
  const email = config.business.contactEmail;
  return (
    <section className="section white offerings-page">
      <div className="container">
        <h1>{IN_HOME.title}</h1>
        <div className="offering-intro">
          {IN_HOME.intro.map((p) => (
            <p key={p}>{p}</p>
          ))}
          <p className="muted currency-note">{CURRENCY_NOTE}</p>
        </div>

        <h2>Sessions</h2>
        <div className="services offering-grid">
          {IN_HOME.services.map((s) => (
            <OfferingCard
              key={s.id}
              id={s.id}
              title={s.title}
              meta={`${s.duration} • ${inHomePriceText(s)}`}
              lead={s.short}
              cta={
                <a className="btn-cta" href={emailHref(`${s.title} booking`)}>
                  Email to book<span className="sr-only">: {s.title}</span>
                </a>
              }
            >
              {s.description.map((p) => (
                <p key={p}>{p}</p>
              ))}
            </OfferingCard>
          ))}
        </div>

        <div className="offering-notes">
          <h2>How to book</h2>
          <p>
            In-home sessions are booked by email. Email{" "}
            <a className="text-link" href={emailHref("In-home art therapy booking")}>{email}</a> to book.
          </p>
          <p>{paymentMethodText(email)}</p>

          <h2>Cancellation Policy</h2>
          <p>
            {sessionCancellationText()} Read more in my{" "}
            <Link className="text-link" to="/policies#refund">Refund &amp; Cancellation Policy</Link> for full details.
          </p>

          <p className="muted offering-help">
            Need help choosing a service? Request a call, and I’ll call you at a time that works for you.
          </p>
          <RequestCallForm collapsible />
        </div>
      </div>
    </section>
  );
}
